import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    to: null,
    classes: {
      default: ""
    },
    target: {
      default: "_self"
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_n_a = _resolveComponent("n-a");

      var _component_router_link = _resolveComponent("router-link");

      return _openBlock(), _createBlock(_component_router_link, {
        to: __props.to,
        custom: ""
      }, {
        default: _withCtx(function (_ref) {
          var navigate = _ref.navigate,
              href = _ref.href;
          return [_createVNode(_component_n_a, {
            href: href,
            onClick: navigate,
            class: _normalizeClass(__props.classes),
            target: __props.target
          }, {
            default: _withCtx(function () {
              return [_renderSlot(_ctx.$slots, "default")];
            }),
            _: 2
          }, 1032, ["href", "onClick", "class", "target"])];
        }),
        _: 3
      }, 8, ["to"]);
    };
  }
});